import React from 'react';
import RAMDashboardConfig from './Dashboards';
import { useAuthorization } from '@hooks/index';

const DashboardAndWidgets = () => {
    const user = useAuthorization();
    const canEdit = user?.canWriteSystemAdminLevel?.(false, false, true);

    if (!user) {
        return null;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <RAMDashboardConfig orgId={user.organisationId} canEdit={canEdit ?? false} />
        </div>
    );
};

export default DashboardAndWidgets;
